import script from "./design.vue?vue&type=script&lang=ts&setup=true"
export * from "./design.vue?vue&type=script&lang=ts&setup=true"

import "./design.vue?vue&type=style&index=0&id=1022ade6&lang=scss"

const __exports__ = script;

export default __exports__